// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2VGvi","right":"styles_right__3iC98"};